import { buildValueMap } from "./utils";

export const SettingCategoryDef = {
    General: { value: 1, label: "General" },
    Email: { value: 2, label: "Email" },
    Templates: { value: 3, label: "Templates" },
    Plaid: { value: 4, label: "Plaid" }
};

export const SettingCategory = buildValueMap(SettingCategoryDef);
